import { render, staticRenderFns } from "./ColorPersColumn.vue?vue&type=template&id=6f5b9968&scoped=true&"
import script from "./ColorPersColumn.vue?vue&type=script&lang=js&"
export * from "./ColorPersColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5b9968",
  null
  
)

export default component.exports